import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorLayout from '../../components/error/ErrorLayout';

export default function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <ErrorLayout
      code={t('errors.maintenance.code')}
      title={t('errors.maintenance.title')}
      message={
        <>
          {t('errors.maintenance.message')}<br />
          {t('errors.maintenance.messageSub')}
        </>
      }
      icon="maintenance"
      accentColor="gold"
    >
      <div className="maintenance-info">
        <div className="maintenance-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '65%' }} />
          </div>
          <p className="progress-text">{t('errors.maintenance.progress')} 65%</p>
        </div>

        <div className="maintenance-details">
          <h4>{t('errors.maintenance.whatWeDo')}</h4>
          <ul>
            <li>{t('errors.maintenance.task1')}</li>
            <li>{t('errors.maintenance.task2')}</li>
            <li>{t('errors.maintenance.task3')}</li>
          </ul>
        </div>
      </div>

      <div className="error-actions">
        <button 
          className="btn btn-primary" 
          onClick={() => window.location.reload()}
        >
          {t('errors.maintenance.checkStatus')}
        </button>
        <a 
          href="https://status.pilotleague.com" 
          className="btn btn-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('errors.maintenance.statusPage')}
        </a>
      </div>

      <div className="error-support">
        <p>
          {t('errors.maintenance.followUs')}{' '}
          <a href="https://twitter.com/pilotleague" target="_blank" rel="noopener noreferrer">
            Twitter
          </a>
          {' '}{t('errors.maintenance.forUpdates')}
        </p>
      </div>
    </ErrorLayout>
  );
}
